import React from "react";

export default function LastFiveDays() {
    return(
        <div className="row d-flex justify-content-center">
            <p>Last Five Days</p>
        </div>
    )
}